import { Pipe, PipeTransform } from '@angular/core';
import { DataTableColumn } from '../models';

@Pipe({
    name: 'headerCellCaption',
    standalone: false
})
export class HeaderCellCaptionPipe implements PipeTransform {
    transform(column: DataTableColumn): string {
        return 'caption' in column ? column.caption : column.dataField;
    }
}
